import { FC, useEffect } from 'react';
import { useSnapshot } from 'valtio';
import MembersStore from '../stores/members-store';
import AppSpinner from '../../common/components/AppSpinner';
import AvailableRolesStore from '../stores/available-roles-store';
import { loadMembersScreen } from '../actions/get-members-actions';
import InviteMemberStore from '../stores/invite-user-store';
import Members from '../components/Members';
import { makeStyles } from 'tss-react/mui';
import { Theme } from '@mui/material';
import { useIsUserReadOnlyRole } from '../hooks/user-role-actions';
import ScanStore from '../../new-scan/store/scan-store';

const MembersContainer: FC<React.PropsWithChildren<unknown>> = () => {
  const { activeMembers: members, isLoading } = useSnapshot(MembersStore);
  const { availableRoles } = useSnapshot(AvailableRolesStore);
  const { pendingInvitationMembers } = useSnapshot(InviteMemberStore);
  const isReadOnlyUser = useIsUserReadOnlyRole();
  const { isDemoEnabled } = useSnapshot(ScanStore);
  const { classes } = useStyles();

  useEffect(() => {
    if (members.length === 0) {
      loadMembersScreen();
    }
  }, [members.length]);

  if (isLoading) {
    return <AppSpinner />;
  }

  return (
    <div className={classes.membersContainer}>
      <Members
        members={members}
        availableRoles={availableRoles}
        isReadOnlyUser={isReadOnlyUser || isDemoEnabled}
        pendingInvitationMembers={pendingInvitationMembers}
      />
    </div>
  );
};

const useStyles = makeStyles()((theme: Theme) => ({
  membersContainer: {
    width: '100%',
  },
}));

export default MembersContainer;
